import Vue from "vue";
import { getLoginInfo as getUserInfo, UserInfo } from "@/utils/getUserInfo";
import { getAwards, getMixedActivityInfo, getTaskInfo, getVideos } from "./index";
import {
  IAwardData,
  IMixActivityInfoData,
  IMyPrizeItem,
  IRemindPrizeItem,
  ITaskData,
  IUserProgress,
  IVideoItem,
  IVideosData
} from "@/types";

export const store = Vue.observable({
  userInfo: {} as UserInfo,
  status: 0, // 用户的任务状态
  isShowBottomDialog: false, // 是否在展示底部弹窗
  taskInfo: {} as ITaskData, // 任务模块的数据
  myPrizeList: [] as IMyPrizeItem[], // 我的奖品
  remindPrizeList: [] as IRemindPrizeItem[], // 已获得奖品
  withdrawValue: 0, // 提现金额
  videoList: [] as IVideoItem[], // 宝藏视频
  scrollDisplayList: [] as string[], // 中奖跑马灯信息
  clueBanner: "", // 每日线索头图
  addressFrom: "/", // 保存地址页跳转的上一个页面
  inBiliApp: false,
  posterData: "", // 海报图base64
  progressData: {} as IUserProgress, // 充能数据
  isLogin: false,
  loading: false, // sharePanel loading
  globalLoading: false, // 全局loading
  canRenderTask: false // 是否能渲染任务模块
});

// 自定义 mutations, 修改属性方法
export const mutations = {
  setUserInfo(info: UserInfo) {
    store.userInfo = info;
  },
  setStatus(status: number) {
    store.status = status;
  },
  setIsShowBottomDialog(isShowBottomDialog: boolean) {
    store.isShowBottomDialog = isShowBottomDialog;
  },
  setTaskInfo(taskInfo: ITaskData) {
    store.taskInfo = taskInfo;
  },
  setMyPrizeList(myPrizeList: IMyPrizeItem[]) {
    store.myPrizeList = myPrizeList;
  },
  setRemindPrizeList(remindPrizeList: IRemindPrizeItem[]) {
    store.remindPrizeList = remindPrizeList;
  },
  setVideoList(videoList: IVideoItem[]) {
    store.videoList = videoList;
  },
  setScrollDisplayList(scrollDisplaylist: string[]) {
    store.scrollDisplayList = scrollDisplaylist;
  },
  setClueBanner(clueBanner: string) {
    store.clueBanner = clueBanner;
  },
  setAddressFrom(from: string) {
    store.addressFrom = from;
  },
  setInBiliApp(inBiliApp: boolean) {
    store.inBiliApp = inBiliApp;
  },
  setPosterData(base64: string) {
    store.posterData = base64;
  },
  setProgressData(data: IUserProgress) {
    store.progressData = data;
  },
  setLoading(b: boolean) {
    store.loading = b;
  },
  setGlobalLoading(b: boolean) {
    store.globalLoading = b;
  },
  setCanRenderTask(b: boolean) {
    store.canRenderTask = b;
  }
};

// 自定义action
export const action = {
  updateUserInfo() {
    return getUserInfo().then((info: UserInfo) => {
      mutations.setUserInfo(info);
      return info;
    });
  },
  updateTaskInfo() {
    return getTaskInfo().then(({ data }: { data: ITaskData }) => {
      const { status } = data;
      mutations.setStatus(status);
      mutations.setTaskInfo(data);
      mutations.setCanRenderTask(true);
    });
  },
  updatePrizes() {
    getAwards().then(({ data }: { data: IAwardData }) => {
      const { my_award, remind_awards } = data;
      mutations.setMyPrizeList(my_award);
      mutations.setRemindPrizeList(remind_awards);
    });
  },
  updateVideos() {
    getVideos().then(({ data }: { data: IVideosData }) => {
      const { ArchiveInfos } = data;
      mutations.setVideoList(ArchiveInfos);
    });
  },
  updateMixedActivityInfo() {
    getMixedActivityInfo().then(({ data }: { data: IMixActivityInfoData }) => {
      const { scroll_display, banner } = data;
      mutations.setScrollDisplayList(scroll_display);
      mutations.setClueBanner(banner);
    });
  }
};
